import React from 'react';
import {Container, Box, LinearProgress, Stack, TableBody, TableRow, TableCell, Typography, Button} from '@mui/material';
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import PlainTable from "../../components/common/PlainTable";
import {useTranslation} from "react-i18next";
import { generateEndpoints } from '../../services/api';
const { useGetNotificationsQuery } = generateEndpoints('notification');

const NotificationsList = () => {
    const {t} = useTranslation();
    const { data: unitTypes = [], isFetching } = useGetNotificationsQuery();

    const columns = [
        {
            title: t('Название'),
            width: '100%',
            dataKey: "title",
        },
        {
            title: t('Файл'),
            width: '100%',
            type: 'file',
            dataKey: "src",
        },
        {
            title: t('Действия'),
            dataKey: "",
            render: (unitType) => (
                <Link to={`/settings/notifications/${unitType.id}`}><Button variant={"outlined"}>{t('Редактировать')}</Button></Link>
            ),
        },
    ];

    return <>
        {isFetching?<LinearProgress />:
            <Box>
                <PlainTable columns={columns} data={unitTypes} />
            </Box>
        }
    </>
    ;
};

export default NotificationsList;